import React from 'react';
import { Route } from 'react-router-dom';
import RouteMenu from 'mrf/view/MenuRoute';
import path from 'path';
import RootTermList from 'components/system/rootTerm/RootTermList';
import RootTermForm from 'components/system/rootTerm/RootTermForm';


export default function RootTerm({ match }) {
    return (
        <RouteMenu match={match} indexComponent={RootTermList}>
            <Route path={path.join(match.url, 'new')} component={RootTermForm} />
            <Route path={path.join(match.url, 'edit/:id')} component={RootTermForm} />
        </RouteMenu>
    );
}